import { uri } from 'utils';

import types from '../types';
import { getCheckboxGroupStateFromURL, getResetedCheckboxGroupState } from '.';

/**
 * @typedef  {Object} Params
 * @property {types.Filter} filter
 * @property {types.Filter[]} filters
 * @property {string} url
 * @property {number} index
 */

/**
 * @param {Params}
 * @returns {types.Filter}
 */
const getFilterInitialStateByFilterType = ({ filter, url }) => {
    switch (filter.type) {
        case 'checkbox': {
            const options = getCheckboxGroupStateFromURL(
                getResetedCheckboxGroupState(filter.options),
                url,
                filter.id
            );

            return {
                ...filter,
                options
            };
        }

        default: {
            return filter;
        }
    }
};

/**
 * Get state primarily by URL parameters with fallback to default values
 * @param {types.Filter[]} filters
 * @param {string} url
 * @returns {types.Filter[]}
 */
const getFiltersInitialStateFromURL = (filters, url) => {
    if (!filters || !Array.isArray(filters) || !filters.length) {
        return [];
    }

    return filters.map((filter, index) =>
        getFilterInitialStateByFilterType({ filter, filters, url, index }));
};

export default getFiltersInitialStateFromURL;
